import { Outlet } from 'react-router-dom';
import CalculatingMarketSnackbar from '@/enterprise/components/CalculatingMarketSnackbar';
import FileDownloadModal from '@/enterprise/components/FileDownloadModal';
import { HydratePendingOfferPolling, OfferStatusPolling } from '@/lib/offerStatusPolling';
import { ServerSentEvents, ServerSentEventsInterval } from '@/lib/serverSentEvents';
import useTrackTwaSession from '@/lib/useTrackTwaSession';
import { useDataDogRumUserAccountIdInitialize } from '@/reporting/DataDog';
import IntercomClickToChat from '@/reporting/IntercomClickToChat';
import PageTracker from '@/reporting/PageTracker';
import AppLayout from '@/shared/components/AppLayout';

const App = () => {
  useDataDogRumUserAccountIdInitialize();
  useTrackTwaSession();

  return (
    <>
      <PageTracker />
      <CalculatingMarketSnackbar />
      <OfferStatusPolling />
      <HydratePendingOfferPolling />
      <ServerSentEvents />
      <ServerSentEventsInterval />
      <IntercomClickToChat />
      <FileDownloadModal />
      <AppLayout>
        <Outlet />
      </AppLayout>
    </>
  );
};

export default App;
